import React from 'react';
import { DirectionalHint } from '@bingads-webui-react/fabric-control';
import _ from 'underscore';
import { StyledBaMenuItem } from '@bingads-webui-react/global-menu';
import classNames from 'classnames';


export function generateSavedReportMenuItem({
  savedReports, i18n, classes, navigate, onClickSavedReportItem, allReportsTitle,
}) {
  const menuText = i18n.getString(_TL_('Saved customized reports'));

  const rootMenuItem = {
    key: 'saved-reports-title',
    className: 'reports-v4-bar-my-reports',
    text: menuText,
    ariaLabel: `${allReportsTitle} ${menuText}`,
    onClick: (event, menuItem) => {
      navigate('reports-v4/my-reports/');
      onClickSavedReportItem({ menuItem });
    },
  };

  if (savedReports['@odata.count'] && savedReports.value.length) {
    _.extend(rootMenuItem, {
      split: true,
      'aria-roledescription': 'split button',
      subMenuProps: {
        directionalHint: DirectionalHint.rightTopEdge,
        calloutProps: {
          preventDismissOnScroll: true,
        },
        items: [],
      },
    });

    rootMenuItem.subMenuProps.items = savedReports.value.map(report => ({
      key: `saved-reports-${report.Id}`,
      onRender: (menuItem, dismissMenu) => (
        <StyledBaMenuItem
          className={classNames([classes.menuItem, classes.toggleable])}
          key={report.Id}
          menuItemKey={report.Id}
          calloutPlacement="right"
          route={`reports-v4/edit/${report.Id}`}
          dismissMenu={dismissMenu}
          closeDropdown={() => dismissMenu(null, true)}
          customizedOnClick={() => {
            navigate(`reports-v4/edit/${report.Id}`);
            onClickSavedReportItem({ menuItem, report });
          }}
          directionalHint={DirectionalHint.rightCenter}
        >
          {report.Name}
        </StyledBaMenuItem>
      ),
    }));
  }

  return rootMenuItem;
}
